<template>
  <div class="page">
    <!--    <div id="map" style="width: 100%; height: 400px;"></div>-->
    <!--    <div id="geolocationControl" style="width: 100px; height: 100px;">-->
    <!--      <van-icon name="aim" size="30" />-->
    <!--    </div>-->
    <iframe id="mapPage" width="100%" height="100%" frameborder=0
            src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=H5VBZ-ON5KN-MJVFF-SPNOF-FKQKZ-L6BP7&referer=user-address">
    </iframe>
  </div>
</template>

<script>

import {wx, wxConfig} from "@/libs/jssdk-util";
import {Dialog} from "vant";
import eventBus from "@/libs/eventBus";

export default {
  name: "location",
  components: {},
  data() {
    return {
      map: null,
      latitude: null,
      longitude: null,
    }
  },
  watch: {},
  methods: {},
  mounted() {

    // 微信JSSDK配置
    wxConfig(['getLocation'],
        () => {

          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
              // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              // var speed = res.speed; // 速度，以米/每秒计
              // var accuracy = res.accuracy; // 位置精度
              this.latitude = res.latitude;
              this.longitude = res.longitude;
            }
            ,
            fail: function (err) {
              alert(JSON.stringify(err))
            }
          })

        }
    )

    // 初始化地图组件
    // this.map = new qq.maps.Map(document.getElementById('map'), {
    //   mapTypeControl: false,
    //   center: new qq.maps.LatLng(this.latitude, this.longitude), // 设置地图中心点经纬度
    //   zoom: 13, // 设置地图缩放级别
    // });

    let that = this
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;
      if (loc && loc.module == 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        Dialog.confirm({
          message: '确认要选择该地址吗',
        }).then(() => {
          eventBus.$emit('confirmLocation', loc)
          that.$router.back(-1)
        })
      }
    }, false);

    // qq.maps.event.addListener(this.map, 'click', (e) => {
    //   const latLng = e.latLng;
    //   console.log('您选择的经度是：' + latLng.lng + '，纬度是：' + latLng.lat);
    //   console.log(e);
    //
    //   // 在这里可以将经纬度信息保存下来，用于后续的地址添加操作
    // });

    // 创建定位控件
    // const geolocationControl = new qq.maps.CustomControl({
    //   content: '定位',
    //   style: {
    //     width: '60px',
    //     height: '30px',
    //     backgroundColor: '#fff',
    //     border: '1px solid #ccc',
    //     textAlign: 'center',
    //     lineHeight: '30px'
    //   },
    //   position: qq.maps.ControlPosition.BOTTOM_RIGHT
    // });
    //
    // this.map.controls[qq.maps.ControlPosition.BOTTOM_RIGHT].push(geolocationControl);

    // maps.init("H5VBZ-ON5KN-MJVFF-SPNOF-FKQKZ-L6BP7",function (){
    //   const center = new maps.LatLng(39.916537, 116.397972);
    //   return  new maps.Map(document.getElementById('map'),{
    //     center: center,
    //         zoom: 13
    //   });
    // })


  },
  beforeRouteLeave(to, from, next){
    if(to.name == 'clerk-detail'){
      eventBus.$off('confirmAddress')
    }
    next()
  },
}
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
}
</style>
